export default __webpack_public_path__ + "static/media/eth-card.82a1cbed.png";